import { JumpToNewMessageButtonProps } from '@azure/communication-react';
import { PcpPrimaryButton } from '../BaseComponents';
import React from 'react';
import { FluentIconsProps } from '@fluentui/react-icons';

const buttonStyles: React.CSSProperties = {
    background: '#1088F9',
    color: 'white',
    borderRadius: '6px',
    height: '32px',
    width: 'fit-content',
};

const NewMessageArrowDownIconFilled = (props: FluentIconsProps) => (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" {...props}>
            <path d="M5.7367 11.925C5.69513 11.9234 5.65537 11.9075 5.6242 11.88C5.58095 11.8517 5.54073 11.819 5.5042 11.7825L0.254201 6.53249C0.182738 6.45365 0.126763 6.36205 0.0892012 6.26249C0.0466463 6.17981 0.016329 6.09139 -0.000799441 5.99999C0.00504006 5.913 0.0227022 5.82722 0.0517003 5.74499C0.0892623 5.64543 0.145239 5.55384 0.216701 5.47499C0.284217 5.4016 0.366685 5.34354 0.458544 5.30473C0.550402 5.26592 0.649516 5.24725 0.749201 5.24999C0.848124 5.24975 0.945992 5.27032 1.03644 5.31037C1.12689 5.35043 1.2079 5.40908 1.2742 5.48249L5.2492 9.44249L5.2492 0.749994C5.24455 0.651431 5.26086 0.553002 5.29706 0.461209C5.33326 0.369417 5.38852 0.286349 5.4592 0.217494C5.53017 0.147079 5.6145 0.0915641 5.70724 0.0542126C5.79997 0.016861 5.89924 -0.00157302 5.9992 -5.96609e-06C6.09812 -0.0035561 6.19676 0.0125095 6.28944 0.0472646C6.38212 0.0820197 6.46701 0.134777 6.5392 0.202494C6.61185 0.273039 6.66827 0.358556 6.70453 0.453104C6.7408 0.547651 6.75604 0.648961 6.7492 0.749994L6.7492 9.44999L10.7617 5.47499C10.8882 5.33863 11.0634 5.25776 11.2492 5.24999C11.349 5.25138 11.4474 5.27266 11.5389 5.31258C11.6303 5.3525 11.7129 5.41027 11.7817 5.48249C11.9191 5.62269 11.9961 5.81118 11.9961 6.00749C11.9961 6.20381 11.9191 6.3923 11.7817 6.53249L6.5317 11.7825C6.50174 11.8157 6.46257 11.8392 6.4192 11.85C6.37366 11.8648 6.33246 11.8905 6.2992 11.925C6.20348 11.9648 6.10237 11.99 5.9992 12C5.90677 11.9976 5.81646 11.9718 5.7367 11.925Z" fill="white"/>
        </svg>
    );

export const PcpJumpToNewMessageButton = (props: JumpToNewMessageButtonProps): React.ReactElement => {
    const { onClick, text } = props;

    return <PcpPrimaryButton
        style={buttonStyles}
        icon={<NewMessageArrowDownIconFilled />}
        iconPosition={'after'}
        onClick={onClick}
    >{text}</PcpPrimaryButton>;
};
